import {FreeCamera} from '@babylonjs/core/Cameras/freeCamera.js';
import {Scene} from '@babylonjs/core/scene.js';
import {Vector3} from '@babylonjs/core/Maths/math.vector.js';
import {Ray} from '@babylonjs/core/Culling/ray.js';
import {MeshBuilder} from '@babylonjs/core/Meshes/meshBuilder.js';
import {obstacles,height,nearby} from './world';
import {Input} from './input';
export class ThirdPersonCamera {
 camera:FreeCamera;yaw=0;pitch=.35;distance=11;
 private target:Vector3;private actualDistance=11;private blockers=new Set<string>();
 constructor(private scene:Scene,target:Vector3) {
  this.target=target.clone();this.camera=new FreeCamera('third-person',target.add(new Vector3(0,3,-11)),scene);
  this.camera.minZ=.08;this.camera.maxZ=180;this.camera.fov=.85;
  // Inflated proxies reserve room for the camera near plane. Trees include canopy.
  for(const [i,o] of obstacles.entries()){
   const width=o.kind==='box'?o.halfX*2:o.radius*2;
   const depth=o.kind==='box'?o.halfZ*2:o.radius*2;
   const tree=false;
   const m=MeshBuilder.CreateBox('camera-blocker-'+i,{width:tree?7:width+.6,depth:tree?7:depth+.6,height:tree?9:o.height+.6},scene);
   m.position.set(o.x,(tree?9:o.height+.6)/2,o.z);m.isVisible=false;m.isPickable=true;
   // Invisible meshes are ray tested explicitly via intersectsMesh.
   this.blockers.add(m.name);
   if(o.kind==='box'&&o.x===14){
    const roof=MeshBuilder.CreateBox('camera-house-roof',{width:10.6,height:5.5,depth:13.6},scene);
    roof.position.set(14,6.45,8);roof.isVisible=false;roof.isPickable=true;this.blockers.add(roof.name);
   }
  }
 }
 update(dt:number,desiredTarget:Vector3,input:Input){
  if(!Number.isFinite(input.yawDelta))input.yawDelta=0;if(!Number.isFinite(input.pitchDelta))input.pitchDelta=0;if(!Number.isFinite(input.zoomDelta))input.zoomDelta=0;
  this.yaw+=input.yawDelta;this.pitch=Math.max(.12,Math.min(1.48,this.pitch+input.pitchDelta));
  this.distance=Math.max(2.5,Math.min(12,this.distance+input.zoomDelta));
  input.yawDelta=input.pitchDelta=input.zoomDelta=0;
  Vector3.LerpToRef(this.target,desiredTarget,1-Math.exp(-12*dt),this.target);
  // Do not let smoothed target enter walls after player moves around a corner.
  const direction=new Vector3(-Math.sin(this.yaw)*Math.cos(this.pitch),Math.sin(this.pitch),-Math.cos(this.yaw)*Math.cos(this.pitch));
  const ray=new Ray(this.target,direction,this.distance);
  let safe=this.distance;
  for(const m of this.scene.meshes)if(this.blockers.has(m.name)){
   m.computeWorldMatrix(true);const hit=ray.intersectsMesh(m,false);
   if(hit.hit)safe=Math.min(safe,Math.max(.25,hit.distance-.1));
  }
  // Sample the full camera boom against terrain and dynamic trunk volumes.
  const closeObstacles=nearby(this.target.x,this.target.z);
  for(let t=.2;t<=safe;t+=.15){
   const p=this.target.add(direction.scale(t));
   if(p.y<height(p.x,p.z)+.3||closeObstacles.some(o=>o.kind==='circle'&&o.x!==0&&Math.hypot(p.x-o.x,p.z-o.z)<(p.y>height(o.x,o.z)+3.5?3.5:o.radius+.3)&&p.y<height(o.x,o.z)+o.height)){safe=Math.max(.2,t-.15);break;}
  }
  // Immediate retract, smooth extension: camera never interpolates through a wall.
  this.actualDistance=safe<this.actualDistance?safe:this.actualDistance+(safe-this.actualDistance)*(1-Math.exp(-6*dt));
  this.camera.position.copyFrom(this.target.add(direction.scale(this.actualDistance)));
  this.camera.position.y=Math.max(this.camera.position.y,height(this.camera.position.x,this.camera.position.z)+.3);
  this.camera.setTarget(this.target);
  this.camera.getViewMatrix(true);this.camera.getProjectionMatrix(true);
 }
}
